import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import styles from "./postreview.module.css";
import {
  usePostReviewMutation,
  useUpdateReviewMutation,
} from "../../../../queries/useReviewQuery";
import {
  Button,
  HeadingTitle,
  Ratings,
} from "../../../../components/shared/index";
import toast from "react-hot-toast";

const PostReviewPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const { productId, vendorId, reviewText: initialText, rating: initialRating } = location.state || {};
  const isEditMode = Boolean(id);
  const navigate = useNavigate();

  const [reviewText, setReviewText] = useState(initialText || "");
  const [rating, setRating] = useState(initialRating || 0);

  const { mutateAsync: postReview, isLoading: isPosting } = usePostReviewMutation();
  const { mutateAsync: updateReview, isLoading: isUpdating } = useUpdateReviewMutation();

  useEffect(() => {
    if (!isEditMode && (!productId || !vendorId)) {
      toast.error("Missing product/vendor info..");
      navigate(-1);
    }
  }, [productId, vendorId, isEditMode, navigate]);

  const handleSubmit = async () => {
    try {
      if (isEditMode) {
        const response = await updateReview({
          reviewId: id,
          payload: { rating, review: reviewText },
        });
        toast.success(response?.message || "Review updated successfully");
      } else {
        const response = await postReview({ product_id: productId, vendor_id: vendorId, rating, review: reviewText });
        toast.success(response?.message || "Review added successfully");
      }
      navigate(-1);
    } catch (e) {
      toast.error(e.message || "Review submit failed");
    }
  };

  return (
    <section className={styles.pageWrapper}>
      <HeadingTitle text={isEditMode ? "Edit Review" : "Write a Review"} style={styles.heading} />

      <div className={styles.card}>
        <div className={styles.ratingWrapper}>
          <span>Your Rating</span>
          <Ratings rating={rating} setRating={setRating} editable={true} />
        </div>

        <textarea
          className={styles.writeTextarea}
          placeholder="Write your review here..."
          value={reviewText}
          onChange={(e) => setReviewText(e.target.value)}
        />

        <div className={styles.actionRow}>
          <Button
            style={styles.submitBtn}
            title={isEditMode ? "Update Review" : "Submit Review"}
            onHandler={handleSubmit}
            disabled={isPosting || isUpdating}
          />
        </div>
      </div>
    </section>
  );
};

export default PostReviewPage;
